var _defs, _g, _image, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffice365(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 -10 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-4 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #307ea9;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-4 {\n        clip-rule: evenodd;\n      }\n\n      .cls-27 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 42.5,
    cy: 42.5,
    r: 33.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18,
    y: 22,
    width: 47,
    height: 38.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.5,44.8c0-.2,0-18.3,0-18.7-3,.7-6.1,1.5-9.1,2.2v12.7c-1.6.6-3.1,1.2-4.7,1.8,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-5.1,0-10.3,0-15.4,0,0,.2,0,.2-.1,4.5-1.7,8.9-3.4,13.4-5.1.2,0,.3,0,.5,0,2.5.7,4.9,1.4,7.4,2.1,0,0,0,0,.1,0v21.7c-.7.2-1.4.4-2.1.6-1.8.5-3.6,1-5.3,1.5-.2,0-.3,0-.5,0-4.4-1.6-8.8-3.3-13.2-4.9,0,0-.2,0-.2-.1,4.5.6,9.1,1.3,13.6,1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 9,
    width: 73,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.5,54.8h-1v-.8h1c0,0,0-.1,0-.1,0-.3,0-.6,0-.9,0-.3,0-.7.2-1,.3-.6.8-1,1.5-1,.2,0,.5,0,.7,0,0,0,0,0,.1,0v.8s0,0-.1,0c-.3-.1-.5-.1-.8,0-.3,0-.4.2-.6.4,0,.1-.1.3-.1.5,0,.4,0,.8,0,1.2h2.3s0,0,0-.1c0-.3,0-.6,0-.9,0-.5.2-1,.6-1.4.3-.3.7-.5,1.1-.5.2,0,.5,0,.7,0,0,0,.1,0,.2,0v.8c-.2,0-.3-.1-.5-.1-.2,0-.3,0-.5,0-.3,0-.4.2-.6.5,0,.2-.1.3-.1.5,0,.4,0,.7,0,1.1,0,0,0,0,0,0h1.4v.8h-1.4v5.1h-.9c0-.2,0-.5,0-.7,0-.2,0-.5,0-.7v-3.7h-2.3v5.1h-.9c0-.2,0-.4,0-.6,0-.2,0-.4,0-.6v-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 9,
    width: 73,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18,55.8c0-.8.1-1.6.5-2.3.5-1.1,1.4-1.8,2.6-2,.7-.1,1.4-.1,2.1,0,1.1.4,1.9,1.1,2.3,2.2.3.7.3,1.5.3,2.2,0,.5-.1,1-.3,1.5-.5,1.4-1.5,2.2-2.9,2.4-.8.1-1.6,0-2.4-.3-1-.4-1.6-1.2-2-2.1-.2-.6-.3-1.2-.3-1.7ZM24.9,55.7c0-.1,0-.3,0-.5,0-.5-.1-1-.4-1.4-.3-.6-.7-1.1-1.4-1.3-.3-.1-.6-.2-1-.2-1.1,0-2,.4-2.5,1.4-.3.5-.4,1-.5,1.6,0,.7,0,1.4.3,2.1.3.7.8,1.3,1.5,1.6.5.2.9.2,1.4.2,1.1,0,1.8-.6,2.3-1.6.3-.6.3-1.2.3-1.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18,
    y: 51.4,
    width: 7.8,
    height: 8.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59,51.7v.9s0,0,0,0c-.3-.2-.7-.2-1.1-.3-.7,0-1.2.2-1.7.6-.3.3-.5.8-.7,1.2-.2.6-.2,1.1-.2,1.7,0,0,0,0,0-.1.2-.4.5-.7.9-.8.2-.1.5-.2.7-.2.3,0,.7,0,1,.1.7.2,1.1.7,1.4,1.4.3.7.2,1.5,0,2.2-.4,1.1-1.4,1.7-2.5,1.6-.8,0-1.4-.4-1.8-1-.3-.4-.5-.9-.6-1.4-.1-.7-.2-1.4,0-2.1,0-.7.2-1.3.5-1.9.2-.6.6-1.1,1.1-1.5.5-.4,1.1-.6,1.7-.6.4,0,.7,0,1.1.1.1,0,.2,0,.3.1M55.3,57.3c0,.4.2.9.5,1.4.5.6,1.2.6,1.8.4.5-.2.7-.6.9-1,.1-.5.1-1,0-1.5-.1-.4-.4-.8-.9-1-.3-.1-.7-.1-1,0-.7.2-1.2.9-1.2,1.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 9,
    width: 73,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.6,55.7c0-1.4.2-2.7.3-4.1h3.8v.8s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h-2.9c0,.8-.1,1.6-.2,2.4,0,0,.1,0,.2,0,.4,0,.8,0,1.2,0,.5,0,1,.2,1.4.6.4.3.7.8.8,1.3,0,.5,0,1.1,0,1.6-.3.8-.8,1.3-1.5,1.5-.5.2-1,.2-1.4.2-.4,0-.7,0-1.1-.2-.1,0-.2,0-.3-.1,0,0,0,0,0-.1,0-.3,0-.6,0-.9,0,0,0,0,.1,0,.4.2.9.4,1.3.5.4,0,.8,0,1.2-.2.6-.3.9-.7,1-1.4,0-.3,0-.5,0-.7-.1-.5-.5-.8-.9-1-.3-.1-.6-.2-.9-.2-.5,0-1,0-1.5,0,0,0,0,0-.1,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 9,
    width: 73,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.1,57.2h-4.1c0,.2,0,.4,0,.6,0,.3.2.6.3.8.3.4.7.6,1.1.6.8.1,1.4,0,2.1-.5,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.4,0,.6,0,.1,0,.2-.1.2-.3.2-.6.3-1,.4-.5.1-1.1.1-1.6,0-.9-.2-1.5-.7-1.8-1.5-.1-.3-.2-.7-.2-1,0-.6,0-1.2.2-1.7.3-.7.7-1.3,1.4-1.6.7-.3,1.4-.4,2.1,0,.6.2,1,.7,1.2,1.3.1.4.2.7.2,1.1,0,.2,0,.5,0,.8ZM45.1,56.4c0-.4,0-.8-.3-1.2-.1-.2-.3-.3-.5-.4-.5-.2-1-.2-1.5.2-.5.3-.7.9-.8,1.4h3.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 9,
    width: 73,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.3,56v-.8c0,0,.1,0,.2,0,.3,0,.6,0,.9,0,.3,0,.5,0,.8-.2.5-.2.8-.6.8-1.1,0-.2,0-.4,0-.6-.1-.5-.5-.8-1-.9-.7-.1-1.4,0-2,.4,0,0,0,0-.1,0,0,0,0,0-.1,0,0-.2,0-.3,0-.5,0-.1,0-.3,0-.4.3-.2.6-.3.9-.4.6-.1,1.2-.2,1.8,0,.6.2,1.1.5,1.3,1,.2.4.2.8.2,1.2,0,.2,0,.5-.2.7-.2.4-.5.7-.9.9-.1,0-.3.1-.4.2,0,0,0,0,0,0,.2,0,.4,0,.6.1.6.2,1.1.6,1.3,1.3.2.9,0,1.7-.7,2.3-.4.4-.9.6-1.4.7-.7.1-1.3,0-2,0-.2,0-.4-.1-.5-.2,0,0,0,0,0-.1,0-.3,0-.6,0-.9,0,0,0,0,0,0,0,0,0,0,.1,0,.8.5,1.6.7,2.5.5.2,0,.5-.2.6-.3.3-.3.5-.6.5-1,0-.2,0-.4,0-.6,0-.3-.3-.6-.6-.8-.3-.2-.6-.2-.9-.3-.4,0-.8,0-1.3,0,0,0-.1,0-.2,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 9,
    width: 73,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.3,54.1v.9c0,0-.1,0-.1,0-.4-.3-.9-.4-1.4-.4-.7,0-1.3.4-1.6,1-.2.3-.2.6-.3.9,0,.4,0,.9.1,1.3.3.8.9,1.3,1.8,1.3.5,0,1-.1,1.4-.4,0,0,0,0,.1,0v.9s0,0-.1,0c-.9.4-1.9.5-2.8,0-.7-.3-1.1-.8-1.3-1.5-.3-1-.3-1.9.2-2.8.5-.9,1.2-1.4,2.2-1.5.5,0,1.1,0,1.6.2,0,0,.2,0,.3.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 9,
    width: 73,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.9,59.9h-.9c0-.1,0-5.6,0-5.9.1,0,.7,0,.9,0,0,.1,0,5.8,0,5.9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 9,
    width: 73,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.8,51.5c0-.3.3-.6.6-.6.4,0,.6.3.6.6,0,.3-.3.6-.6.6-.4,0-.6-.3-.6-.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 9,
    width: 73,
    height: 65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8,
    y: 8,
    width: 69,
    height: 69
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 74,
    height: 66,
    transform: "translate(5 8)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABCCAYAAAAfQSsiAAAACXBIWXMAAAsSAAALEgHS3X78AAAE10lEQVR4nO2c627rMAyDlaLv/8an2Y/Bm6qQlHzruoMRCOI4ju18pWUn7Wb2pz/t0PFTDZ/nuaXt4zjOHfWavRhWB6CsXAnIanDbYRUAofPqGgaAglkFbRssASnmZ8ewepJGx5+VLgC2FFbioqOQRseXZsTxScp8VjwJ7D5zsVfRSVlaQTT7hHC4NDqnykxpibM6Qal9tT/eQdFNPs9Cespd084ioKqQWBrVEwF4J3lQW1wVO9OtQVB+i3nomqcm3V5tBtLfnRp017KY1foh9gwYg8eUgXrY1WHNgVMahgVclYGqbmYcWAbJzOxm38CWapWzFDi13Ui+2RUYGoIPt2+QUH+WuGvHMFSgEBwGTMUs7xyfF1291F0rYSlQEcgN5N9IHV5+Fny4PK8GzcctVK5bK2ChIchAoXQGzCvOeIeZ/QNttu0tnRVdoIZgtkexK66xmntiID9BHf78FMBdMat3GEZ3xbrMnh3VgvnNnmNXdZIY0hAst2xAe59mkKrOim6Nw9AD+xXDkAGrBvtsa3X46f9BynqnoQliSq9YwVdhsPL+fNPNpU+7gkGOnNZqWF4s6BvIj3nxXEyzYacAT2v1OqvtEaQsvsWyPRBVrFumW16kS8xJ8TxzjKoP1ZvBWQpvFazshkc6q8Cz2XKru1Y7a7e2DK+qXgGLvfpV52Na5b1Mq2BlEGIZ9mYzXld6r/4q7XJW1TnZq+AIych59gEs1cqlg19hHyGvpf2+qV1TdU4VCmtvWF2wwqvkLNh6eP4RhDmlPecZKBPLjwzPr7b9ffR8eZHCGvy1S3QZAuLLxnQsFx2qhisb9k1PH9h5nkcVGIVVhKTKRFCWHLN0PJ6JU/A5sd1rBg3C6vzlC3pm88e+DBuCKn3pnl0BsWHZ2i45J3PZBdbkT4TYtegGfH68IQRVuQtdMyQF7B4LJnVljyDlPolj5oQIs71SzpYgUcj5zw0RYHdfgFQeG0DHFalg68+p4G6GASF3tQ+ThQbffkmVpYN6qeY7pR5eY4djfhyOJznvr6sA83XGfqvlDHTXvZ0AN+IrZmn29J+JfZr+WxsGX8UtJjbpSGBRyllVUKxM7wKW5TNglTjFIKA14KVsdFfv4w4CxdJm/EazoRHLIWdUnZX1oRy3emIWWh5UoSmxmU/NWiNDcVoMVjb7xVhVcVfVZeby4qLW7Oo+JLUwRm2XXJY5i0FiZUaWGKizyFlsqJppd7Gnh26NvqLJgjsq75UNMyS1UK24DfWpC2APrN7HoOoMqIbY6DKkd3iWFqr3XX9wZHM32zt02IJ0qe7HcZwbgTWpTzpzWG8b28D1DMPMKWhdxGYiC+djekQs8McyWTvDs2FWKVoBI7dsXwOBdtTKfuhDGoGVwel63hL1M2Xujmnlsi5lsNjCzUI6Nj4KKtajzquH7HisXFZp08w4LBWfKlNudSZU9a+6FoEacltlGKrAzTTjrKpU/ZXh2D1rKlhoyLG8dxML4ApQeh8jSwe2NHgnaNXZT/Y5vin9iiuDf9Os4tLuhS4TA6AgwWtGYF3KkmOW95OqDLcSKLNwc4PfGVbO/bS6Y1QKy6wEjF77S5TGVvYlK7zhiQfrdwTYNfGor+/lzb3gbcTbqPJLmhKM/xlaz++zpiD8Rog7/wvSn5w+AE40cz7ar1MfAAAAAElFTkSuQmCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 8,
    width: 74,
    height: 66
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 30.6,
    y: 21,
    width: 23.6,
    height: 28
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 25.5,
    y: 50,
    width: 8.8,
    height: 10.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 17,
    y: 50.4,
    width: 9.8,
    height: 10.6
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 53.2,
    y: 50.5,
    width: 7.4,
    height: 10.6
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 59.4,
    y: 50.6,
    width: 6.7,
    height: 10.4
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.9,
    y: 52.7,
    width: 7.2,
    height: 8.4
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 47.5,
    y: 50.4,
    width: 6.9,
    height: 10.7
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 34.7,
    y: 52.8,
    width: 6.6,
    height: 8.4
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 32.9,
    y: 53,
    width: 3,
    height: 7.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 32.8,
    y: 49.9,
    width: 3.3,
    height: 3.3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice365);
export default __webpack_public_path__ + "static/media/office365.bbb1130e5413ee82810c693803c91c31.svg";
export { ForwardRef as ReactComponent };